import clsx from "clsx";
import { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { selectIsAuth, selectIsLogin } from "../../features/authentication/services";
import { useAppSelector } from "../../hooks";
import PageLoader from "../loader/PageLoader";
import TopNav from "../nav/TopNav";
import styles from "./PrivateLayout.module.scss";

const drawerWidth = 240;

const PrivateLayout = () => {
    const isLogin = useAppSelector(selectIsLogin);
    const isAuth = useAppSelector(selectIsAuth);
    const [sideBarOpen, setSideBarOpen] = useState(true);
    const handleSideBarOpen = () => {
        setSideBarOpen(!sideBarOpen);
    };

    if (!isLogin) {
        return isAuth === "loading" ? <PageLoader loading={true} /> : <Navigate to='/' replace />;
    }
    return (
        <>
            <div className={clsx(styles.box, { [styles.sideBarOpen]: sideBarOpen })}>
                <TopNav drawerWidth={drawerWidth} sideBarOpen={sideBarOpen} handleSideBarOpen={handleSideBarOpen} />
                <main className={styles.main}>
                    <Outlet />
                </main>
            </div>
        </>
    );
};
export default PrivateLayout;
